// extracted by mini-css-extract-plugin
export var breadcrumb = "_1h-0";
export var breadcrumbArrow = "_1h-1";